'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _RaisedButton = require('material-ui/RaisedButton');

var _RaisedButton2 = _interopRequireDefault(_RaisedButton);

var _FlatButton = require('material-ui/FlatButton');

var _FlatButton2 = _interopRequireDefault(_FlatButton);

var _Stepper = require('material-ui/Stepper');

var _reactIntl = require('react-intl');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var StepperComponent = function (_React$Component) {
  _inherits(StepperComponent, _React$Component);

  function StepperComponent(props, context) {
    _classCallCheck(this, StepperComponent);

    var _this = _possibleConstructorReturn(this, (StepperComponent.__proto__ || Object.getPrototypeOf(StepperComponent)).call(this, props, context));

    _this.handleNext = function () {
      var stepIndex = _this.state.stepIndex;

      _this.setState({
        stepIndex: stepIndex + 1,
        finished: stepIndex >= _this.props.steps.length - 1
      });
    };

    _this.handlePrev = function () {
      var stepIndex = _this.state.stepIndex;

      if (stepIndex > 0) {
        _this.setState({
          finished: false,
          stepIndex: stepIndex - 1
        });
      }
    };

    _this.state = {
      finished: false,
      stepIndex: 0
    };
    _this.messages = (0, _reactIntl.defineMessages)({
      FINISH: {
        id: 'FINISH',
        description: 'Finish title',
        defaultMessage: 'Finish'
      },
      BACK: {
        id: 'BACK',
        description: 'Back title',
        defaultMessage: 'Back'
      },
      NEXT: {
        id: 'NEXT',
        description: 'Next title',
        defaultMessage: 'Next'
      }
    });
    _this.renderStep = _this.renderStep.bind(_this);
    return _this;
  }

  _createClass(StepperComponent, [{
    key: 'renderStepActions',
    value: function renderStepActions(step) {
      var stepIndex = this.state.stepIndex;
      var formatMessage = this.props.intl.formatMessage;


      return _react2.default.createElement(
        'div',
        { style: { margin: '12px 0' } },
        _react2.default.createElement(_RaisedButton2.default, {
          label: stepIndex === this.props.steps.length - 1 ? formatMessage(this.messages.FINISH) : formatMessage(this.messages.NEXT),
          style: { marginRight: 12 },
          onTouchTap: this.handleNext,
          disableTouchRipple: true,
          disableFocusRipple: true,
          primary: true
        }),
        step > 0 && _react2.default.createElement(_FlatButton2.default, {
          label: formatMessage(this.messages.BACK),
          disabled: stepIndex === 0,
          onTouchTap: this.handlePrev,
          disableTouchRipple: true,
          disableFocusRipple: true
        })
      );
    }
  }, {
    key: 'renderStep',
    value: function renderStep(step, index) {
      return _react2.default.createElement(
        _Stepper.Step,
        { key: index },
        _react2.default.createElement(
          _Stepper.StepLabel,
          null,
          step.title
        ),
        _react2.default.createElement(
          _Stepper.StepContent,
          null,
          _react2.default.createElement(
            'p',
            null,
            step.message
          ),
          this.renderStepActions(index)
        )
      );
    }
  }, {
    key: 'render',
    value: function render() {
      var _props = this.props,
          steps = _props.steps,
          finishMessage = _props.finishMessage;
      var _state = this.state,
          finished = _state.finished,
          stepIndex = _state.stepIndex;

      return _react2.default.createElement(
        'div',
        { style: { width: 380, height: 400, margin: 'auto' } },
        _react2.default.createElement(
          _Stepper.Stepper,
          { activeStep: stepIndex, orientation: 'vertical' },
          steps.map(this.renderStep)
        ),
        finished && _react2.default.createElement(
          'p',
          { style: { margin: '20px 0', textAlign: 'center' } },
          finishMessage
        )
      );
    }
  }]);

  return StepperComponent;
}(_react2.default.Component);

StepperComponent.propTypes = {
  intl: _reactIntl.intlShape.isRequired,
  steps: _react2.default.PropTypes.array.isRequired,
  finishMessage: _react2.default.PropTypes.oneOfType([_react2.default.PropTypes.string, _react2.default.PropTypes.node])
};
StepperComponent.defaultProps = {
  steps: []
};
exports.default = (0, _reactIntl.injectIntl)(StepperComponent);


/*****************
 ** WEBPACK FOOTER
 ** ./~/@its/components/lib/Presentational components/Stepper/Stepper.js
 ** module id = 502
 ** module chunks = 0
 **/